import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/btc-tools/')({
  component: () => <Navigate to="/btc-tools/schedule" />,
});
